import * as Highcharts from "highcharts";
import { ChartEventsOptions, LangOptions } from "highcharts";

export class UtilidadMercadoCambiario {

    private isFestivoInUsa(consultaFestivoUsa: string): boolean {
        try {
            if ('FESTIVO_USA_S' === consultaFestivoUsa) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }

    public obtenerMes(idMes: number): string {
        if (idMes == 0) {
            return 'Enero';
        } else if (idMes == 1) {
            return 'Febrero';
        } else if (idMes == 2) {
            return 'Marzo';
        } else if (idMes == 3) {
            return 'Abril';
        } else if (idMes == 4) {
            return 'Mayo';
        } else if (idMes == 5) {
            return 'Junio';
        } else if (idMes == 6) {
            return 'Julio';
        } else if (idMes == 7) {
            return 'Agosto';
        } else if (idMes == 8) {
            return 'Septiembre';
        } else if (idMes == 9) {
            return 'Octubre';
        } else if (idMes == 10) {
            return 'Noviembre';
        } else {
            return 'Diciembre';
        }
    }

    public chartEventsOptions(): ChartEventsOptions {
        let fuente: string = 'Sistema de Negociación de Divisas SetIcap-FX';
        let textoZonaHoraria: string = 'COT(Colombia time) UTC/GMT-5';
        let textoAddFuenteZonaHoraria: string = 'Transacciones entre las 08:00 y las 13:00 horas ' + textoZonaHoraria;
        let textoFuenteAdd: string = 'Los datos presentados en la gráfica corresponden a los promedios ponderados por montos de las negociaciones';
        let textoFuenteAdd2: string = 'ejecutadas y/o registradas a través del sistema de negociación y  registro SetIcap-FX y que son publicados por dicha entidad.';
        let textoFuenteAdd3: string = 'Adicionalmente, los datos no son en tiempo real en la medida que su procesamiento requiere de un par de minutos.';
        return {
            load: function () {
                var labelFuentes = '<span style="font-weight: bold; font-size: 12px;">Fuente: </span> <br/>';
                labelFuentes = labelFuentes
                    + '<span style="color: black; font-size: 11px; margin-bottom:30px; position: absolute;">'
                    + fuente
                    + '.</span><br/>'
                    + '<span style="color: black; font-size: 11px; margin-bottom:30px; position: absolute;">'
                    + textoAddFuenteZonaHoraria
                    + '.</span><br/>'
                    + '<span style="color: black; font-size: 11px; margin-bottom:30px; position: absolute;">'
                    + textoFuenteAdd
                    + '</span><br/>'
                    + '<span style="color: black; font-size: 11px; margin-bottom:30px; position: absolute;">'
                    + textoFuenteAdd2
                    + '</span><br/>'
                    + '<span style="color: black; font-size: 11px; margin-bottom:30px; position: absolute;">'
                    + textoFuenteAdd3
                    + '</span><br/>';
                var textoFuente = this.renderer.text(
                    labelFuentes).css({
                        textAlign: 'left',
                    }).attr({
                        padding: 20,
                        r: 30,
                        zIndex: 30
                    }).add();
                textoFuente.align(Highcharts.extend(textoFuente
                    .getBBox(), {
                    x: 6,
                    y: 500
                }), null!, 'spacingBox');
            }
        }
    }

    public langOptions(): LangOptions {
        return {
            noData: 'Sin datos para mostrar',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril',
                'Mayo', 'Junio', 'Julio', 'Agosto',
                'Septiembre', 'Octubre', 'Noviembre',
                'Diciembre'],
            weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles',
                'Jueves', 'Viernes', 'Sábado'],
            shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May',
                'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            //exportButtonTitle : "Exportar",
            downloadPNG: '<img src="/estadisticas-economicas/assets/img/exporttocsv_ena.png"/> Descargar imagen PNG',// 'Descargar
            // imagen
            // PNG',
            downloadJPEG: '<img src="/estadisticas-economicas/assets/img/exporttocsv_ena.png"/> Descargar imagen JPEG',
            downloadPDF: '<img src="/estadisticas-economicas/assets/img/exporttopdf_ena.png"/> Descargar imagen PDF',
            downloadSVG: '<img src="/estadisticas-economicas/assets/img/exporttoxml_ena.png"/> Descargar imagen SVG',
            downloadCSV: '<img src="/estadisticas-economicas/assets/img/exporttocsv_ena.png"/> Descargar datos en CSV',
            // downloadXLSX: '<img
            // src="'+getContexto()+'/images/exporttoexcel_ena.png"/>
            // Descargar datos en XLS',
            printChart: '<img src="/estadisticas-economicas/assets/img/exporttocsv_ena.png"/> Imprimir',
            thousandsSep: ".",
            decimalPoint: ',',
            contextButtonTitle: 'Opciones de descarga',
            numericSymbolMagnitude: 1000,
        }
    }

    public xAxisOptions(): Array<Highcharts.XAxisOptions> {
        let listaAxis: Array<Highcharts.XAxisOptions> = new Array();
        let xAxis: Highcharts.XAxisOptions = {
            type: 'datetime',
            minorTickInterval: 1,
            startOnTick: true,
            endOnTick: true,
            gridLineWidth: 1,
            tickInterval: 5 * 60 * 1000,
            title: {
                text: 'Hora de la Transacción',
                margin: 10,
                style: {
                    fontSize: '11px',
                    fontWeight: 'bold',
                    color: 'rgb(128, 128, 128)',
                    fontFamily: 'arial, sans-serif'
                }
            },
            labels: {
                formatter: function () {
                    var fecha = new Date(Number(this.value));
                    return fecha.toLocaleTimeString();
                },
                rotation: -90,
                style: {
                    fontSize: '11px',
                    fontWeight: 'normal',
                    color: 'rgb(51, 51, 51)',
                    fontFamily: 'Arial,sans-serif'
                }

            }
        };
        listaAxis.push(xAxis);
        return listaAxis;
    }

    public yAxisOptions(): Array<Highcharts.YAxisOptions> {
        let listaAxis: Array<Highcharts.YAxisOptions> = new Array();
        let yAxis: Highcharts.YAxisOptions = {
            minorTickInterval: 2.5,
            gridLineWidth: 1,
            title: {
                text: 'Precio promedio ponderado (COP/USD)',
                margin: 20,
                style: {
                    fontSize: '11px',
                    fontWeight: 'bold',
                    color: 'rgb(128, 128, 128)',
                    fontFamily: 'tahoma, sans-serif'
                }
            },
            labels: {
                formatter: function (): string {
                    return '$' + this.value;
                },
                style: {
                    fontSize: '11px',
                    fontWeight: 'normal',
                    color: 'rgb(51, 51, 51)',
                    fontFamily: 'Arial,sans-serif'
                }
            }
        }
        listaAxis.push(yAxis);
        return listaAxis;
    }

    public getDatosSerieJson(data:string) {
        var fecha = new Date();
        try {
          fecha = new Date(Number(data));
        } catch (error) {
          fecha = new Date();
        }
        const fechaSerie_timeZone = fecha.toLocaleString('es-CO', {
          day : 'numeric',
          year : 'numeric',
          month : 'long',
          timeZone : 'America/Bogota'
        });
      
        return fechaSerie_timeZone;
      }

      public getTituloActualizado(consultaFestivoUsa: string):string{
        let textoZonaHoraria: string = 'COT(Colombia time) UTC/GMT-5';
        let titulo;
        var fecha = new Date();
        const fechaTitulo_timeZone = fecha.toLocaleString('es-CO', {
            day : 'numeric',
            year : 'numeric',
            month : 'long',
            hour : '2-digit',
            minute : 'numeric',
            second : 'numeric',
            hour12 : false,
            timeZone : 'America/Bogota'
        });
        titulo = 'Fecha y hora actual, ' + fechaTitulo_timeZone + ', ' + textoZonaHoraria;
        if(this.isFestivoInUsa(consultaFestivoUsa)){
            var fecha = new Date();
            const fechaFestivo_timeZone = fecha.toLocaleString('es-CO', {
                day : 'numeric',
                year : 'numeric',
                month : 'long',
                timeZone : 'America/Bogota'
            });
            var mensaje = '<span style="color:#FF0000;">Los datos visualizados el día de hoy corresponden al mercado "next day" debido al festivo en Estados Unidos.</span>';
            titulo = titulo + '<br/>' + mensaje;
        }
        return titulo;
      }
}